import { handleActions } from 'redux-actions';

import { getResult } from 'shared/redux/helpers/normalized';

import { NAMES as SERVER_CHANNELS_LIST } from 'shared/redux/server/actions/channels/list';
import { NAMES as SERVER_CHANNELS_SEARCH } from 'shared/redux/server/actions/channels/search';
import { NAMES as SERVER_CHANNEL_UPDATE } from 'shared/redux/server/actions/channel/update';
import { NAMES as SERVER_CHANNEL_REMOVE } from 'dashboard/redux/server/actions/channel/remove';


export default handleActions({
  [SERVER_CHANNELS_LIST.SUCCESS]: getResult,

  [SERVER_CHANNELS_SEARCH.SUCCESS]: getResult,

  [SERVER_CHANNEL_REMOVE.SUCCESS]: (state, { payload }) => {
    const { id } = payload.params;

    return _.without(state, id);
  },

  [SERVER_CHANNEL_UPDATE.SUCCESS]: (state, { payload }) => {
    const { result } = payload.response.data;
    return [
      result,
      ..._.without(state, result),
    ];
  },
}, []);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/channels/ids.js